import React from 'react'
import { Outlet } from 'react-router-dom'

function MainReport() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainReport
